import { BaseBritishColumbiaObstetricalFileSubSection, BaseBritishColumbiaObstetricalFileSubSectionProps } from "@/Patient/Components/MedicalNote/Obstetric/Form/BritishColumbia/Subcomponent/BaseBritishColumbiaObstetricalFileSubSection";
import { BritishColumbiaObstetricalFileMedicalHistoryCardiovascular } from "./Section7/BritishColumbiaObstetricalFileMedicalHistoryCardiovascular";
import { BritishColumbiaObstetricalFileMedicalHistoryEndocrine } from "./Section7/BritishColumbiaObstetricalFileMedicalHistoryEndocrine";
import { BritishColumbiaObstetricalFileMedicalHistoryImmunizations } from "./Section7/BritishColumbiaObstetricalFileMedicalHistoryImmunizations";
import { BritishColumbiaObstetricalFileMedicalHistoryInfectiousDiseases } from "./Section7/BritishColumbiaObstetricalFileMedicalHistoryInfectiousDiseases";
import { BritishColumbiaObstetricalFileMedicalHistoryMentalHealth } from "./Section7/BritishColumbiaObstetricalFileMedicalHistoryMentalHealth";

class BritishColumbiaObstetricalFileSection7 extends BaseBritishColumbiaObstetricalFileSubSection<BaseBritishColumbiaObstetricalFileSubSectionProps, never> {
    private sectionId = "MedicalHistory_Section7";
    private medicalHistoryHematology = `${this.sectionId}_Hematology`;

    public render(): JSX.Element {
        const section7 = this.props.form.Section7;

        return (
            <div className="section">
                <div className="row row-form">
                    {this.renderHeader(
                        "AntecedentsMedicauxLabel",
                        7
                    )}
                    <div className="col-md-12">
                        {this.renderNoYesTitleSection5To9()}
                    </div>
                    {this.renderRadioButtonsWithTextBox({
                        value: section7.Surgery,
                        id: `${this.sectionId}_Surgery`,
                        label: "SurgeryLabel",
                        onChangeBoolean: value => this.props.mutateModelStateWithFormUpdate(s => s.Section7.Surgery.Value = value),
                        onChangeDescription: value => this.props.mutateModelState(s => s.Section7.Surgery.setDescription(value)),
                        maxLength: this.page1FieldLimits.MedicalHistory_SurgeryDescription.MaxChars
                    })}
                    {this.renderRadioButtonsWithTextBox({
                        value: section7.AnestheticComplications,
                        id: `${this.sectionId}_AnestheticComplications`,
                        label: "ObstetricalFile_AnestheticComplicationsLabel",
                        onChangeBoolean: value => this.props.mutateModelStateWithFormUpdate(s => s.Section7.AnestheticComplications.Value = value),
                        onChangeDescription: value => this.props.mutateModelState(s => s.Section7.AnestheticComplications.setDescription(value)),
                        maxLength: this.page1FieldLimits.MedicalHistory_AnestheticComplicationsDescription.MaxChars
                    })}
                    {this.renderRadioButtonsWithTextBox({
                        value: section7.Neuro,
                        id: `${this.sectionId}_Neuro`,
                        label: "NeuroLabel",
                        onChangeBoolean: value => this.props.mutateModelStateWithFormUpdate(s => s.Section7.Neuro.Value = value),
                        onChangeDescription: value => this.props.mutateModelState(s => s.Section7.Neuro.setDescription(value)),
                        maxLength: this.page1FieldLimits.MedicalHistory_NeuroDescription.MaxChars
                    })}
                    {this.renderRadioButtonsWithTextBox({
                        value: section7.Respiratory,
                        id: `${this.sectionId}_Respiratory`,
                        label: "RespiratoryAbbreviationLabel",
                        onChangeBoolean: value => this.props.mutateModelStateWithFormUpdate(s => s.Section7.Respiratory.Value = value),
                        onChangeDescription: value => this.props.mutateModelState(s => s.Section7.Respiratory.setDescription(value)),
                        maxLength: this.page1FieldLimits.MedicalHistory_RespDescription.MaxChars
                    })}
                    <BritishColumbiaObstetricalFileMedicalHistoryCardiovascular {...this.props} />
                    {this.renderRadioButtonsWithTextBox({
                        value: section7.AbdominalGastrointestinal,
                        id: `${this.sectionId}_AbdominalGastrointestinal`,
                        label: "AbdominalGastrointestinalAbbrevLabel",
                        onChangeBoolean: value => this.props.mutateModelStateWithFormUpdate(s => s.Section7.AbdominalGastrointestinal.Value = value),
                        onChangeDescription: value => this.props.mutateModelState(s => s.Section7.AbdominalGastrointestinal.setDescription(value)),
                        maxLength: this.page1FieldLimits.MedicalHistory_AbdomenGastrointestinalDescription.MaxChars
                    })}
                    {this.renderRadioButtonsWithTextBox({
                        value: section7.GynoGenitourinary,
                        id: `${this.sectionId}_GynoGenitourinary`,
                        label: "GynoGenitourinaryAbbrevLabel",
                        onChangeBoolean: value => this.props.mutateModelStateWithFormUpdate(s => s.Section7.GynoGenitourinary.Value = value),
                        onChangeDescription: value => this.props.mutateModelState(s => s.Section7.GynoGenitourinary.setDescription(value)),
                        maxLength: this.page1FieldLimits.MedicalHistory_GyneGenitourinaryDescription.MaxChars
                    })}
                    <div className="col-md-12 inline-radio-textbox inline-selection-justify-between">
                        {this.renderBooleanRadioButtonsBeforeTextbox({
                            value: section7.Hematology,
                            id: this.medicalHistoryHematology,
                            onChangeBoolean: value => this.props.mutateModelStateWithFormUpdate(s => s.Section7.Hematology.Value = value),
                            onChangeDescription: value => this.props.mutateModelState(s => s.Section7.Hematology.setDescription(value)),
                            radioWrapperClassName: "align-items-start",
                            radioClassName: "flex-display-inline"
                        })}
                        <label className="margin-none">{this.getString("ObstetricalFile_HematologyLabel")}</label>
                    </div>
                    {this.getAdditionalTextBox({
                        id: this.medicalHistoryHematology,
                        value: section7.Hematology.Description,
                        onChange: value => this.props.mutateModelState(s => s.Section7.Hematology.setDescription(value)),
                        maxLength: this.page1FieldLimits.MedicalHistory_HematologyDescription.MaxChars,
                        valueStyle: { padding: "5px 15px 5px 55px", marginLeft: "5px" }
                    })}
                    <BritishColumbiaObstetricalFileMedicalHistoryEndocrine {...this.props} />
                    <BritishColumbiaObstetricalFileMedicalHistoryMentalHealth {...this.props} />
                    <BritishColumbiaObstetricalFileMedicalHistoryInfectiousDiseases {...this.props} />
                    <BritishColumbiaObstetricalFileMedicalHistoryImmunizations {...this.props} />
                    {this.renderRadioButtonsWithTextBox({
                        value: section7.Other,
                        id: `${this.sectionId}_MedicalHistoryOther`,
                        label: "ObstetricalFile_OtherLabel",
                        onChangeBoolean: value => this.props.mutateModelStateWithFormUpdate(s => s.Section7.Other.Value = value),
                        onChangeDescription: value => this.props.mutateModelState(s => s.Section7.Other.setDescriptionAndCheckbox(value)),
                        maxLength: this.page1FieldLimits.MedicalHistory_OtherDescription.MaxChars
                    })}
                    {this.renderAllEmptyFieldAsNoLink(
                        () => this.props.mutateModelStateWithFormUpdate(s => s.Section7.setEmptyFieldsAsNo())
                    )}
                </div>
            </div>
        );
    }
}

export { BritishColumbiaObstetricalFileSection7 };
